import { render } from "./ArrowLeftIcon.vue?vue&type=template&id=aa404ef8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__